import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useRoutes, useLocation } from "react-router-dom";
import { AppRoute } from './config/app-route.jsx';
import { slideToggle } from './composables/slideToggle.js';
import * as Sentry from "@sentry/browser";

// bootstrap
import 'bootstrap';

// css
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './index.css';
import './scss/styles.scss';
import { Provider } from 'react-redux';

import AuthMiddleware from './Auth/AuthMiddleware.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import store from './store.js';

const container = document.getElementById('root');
const root = createRoot(container);


function App() {
	const element = useRoutes(AppRoute);
	let location = useLocation();

	// on every route change
	React.useEffect(() => {
		var elm = document.querySelector('.app');
		if (elm) {
			elm.classList.remove('app-sidebar-mobile-toggled');
		}
		var elm2 = document.querySelector('.app-top-nav');
		if (elm2 && elm2.style.display === 'block') {
			slideToggle(document.querySelector('.app-top-nav'));
		}
	}, [location]);

	return element;
}
Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DNS });
root.render(
	<Provider store={store}>
		<ToastContainer />
		<BrowserRouter>
			<AuthMiddleware>
				<App />
			</AuthMiddleware>
		</BrowserRouter>
	</Provider>
);
